import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import TableauEmbedded from './TableauEmbedded';

export default function Dashboard(): JSX.Element {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <TableauEmbedded />
      </MainLayout>
    </div>
  );
}
